<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='Tx_VenClasss' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white fh" id='txVenClasss-table'>
        <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                  @selection-change="handleSelectionChange" @sort-change="handleSortChange"
                  row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" :load="load" lazy>
          <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in headerList" hasChildren: true :key="index" :min-width="item.width"
                           :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                           :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                           v-if="item.isSel">
              </select-type>
              <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{ scope.row[item.key] | dateFormat }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
      </div>

      <!--使用createdFormId设置Dialog的id,通过id设置内部的样式，防止样式污染-->
      <add-instance ref="dataForm" :sourceCode="crmType"
                    createdFormId="txVenClasss-dialog"
                    :visible.sync="dialogFormVisible"
                    :initData="initData" :soltNameArray="soltNameArray">
        <treeselect slot="parentClassification" :normalizer="normalizer" :options="modulesTreeRoot"
                    :default-expand-level="3" :multiple="false" :open-on-click="true" :open-on-focus="true"
                    :clear-on-select="true"
                    v-model="dpSelectModule"></treeselect>
      </add-instance>

      <edit-instance ref="editForm" :sourceCode="crmType"
                     createdFormId="txVenClasss-dialog"
                     :visible.sync="dialogEditVisible"
                     :initData="temp" :soltNameArray="soltNameArray">
        <treeselect slot="parentClassification" :normalizer="normalizer" :options="modulesTreeRoot"
                    :default-expand-level="3" :multiple="false" :open-on-click="true" :open-on-focus="true"
                    :clear-on-select="true"
                    v-model="dpSelectModule"></treeselect>
      </edit-instance>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>

      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>
    </div>
  </div>
</template>

<script>
import * as txVenClasss from '@/api/tx_venclasss';
import mytable from '@/utils/crmtableFlowV2';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'txVenClasss',
  components: { Treeselect },
  mixins: [mytable],
  data() {
    return {
      crmType: 'Tx_VenClass',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: '',
        parentClassification: ''
      },
      rules: {},
      normalizer(node) {
        // treeselect定义字段
        return {
          label: node.classificationName,
          id: node.classification,
          children: node.children
        };
      },
      modules: [],
      modulesTree: [], // 用户可访问到的所有模块组成的树
      soltNameArray: ['parentClassification']
    };
  },
  created() {
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId();
  },
  computed: {
    modulesTreeRoot() {
      const root = [{
        classificationName: '根节点',
        parentClassification: '',
        id: '',
        classification: ''
      }];
      return root.concat(this.modulesTree);// 用户可访问到的所有模块组成的树
    },
    dpSelectModule: {
      // 模块编辑框下拉选中的模块
      get: function() {
        if (this.dialogFormVisible) {
          return this.initData.parentClassification;
        } else {
          return this.temp.parentClassification;
        }
      },
      set: function(v) {
        // 如果是根节点
        if (v === undefined || v === null || !v) {
          if (this.dialogFormVisible) {
            this.initData.parentClassification = null;
            this.$refs['dataForm'].$refs['frmData'].AssignmentModel('parentClassification', null);
          } else {
            this.$refs['editForm'].$refs['frmEditData'].AssignmentModel('parentClassification', null);
          }
          return;
        }
        if (this.dialogFormVisible) {
          this.$refs['dataForm'].$refs['frmData'].AssignmentModel('parentClassification', v);
        } else {
          this.$refs['editForm'].$refs['frmEditData'].AssignmentModel('parentClassification', v);
        }
      }
    }
  },
  methods: {
    getApi() {
      return txVenClasss;
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'txVenClasss') {
        this.drawertemp = { ...this.drawertemp, ...row };
        this.menukeyArray = [
          { name: '', menukey: 'tx_venclasssview' }
        ]; // 要显示的标签
        this.drawer = true;
      }
    },
    load(tree, treeNode, resolve) {
      txVenClasss.getChildrenData(tree.classification).then(res => {
        resolve(res.result);
      });
    },
    getModulesTree() {
      var _this = this; // 记录vuecomponent
      txVenClasss.getAllData().then(response => {
        _this.modules = response.result.map(function(item) {
          return {
            id: item.id,
            classification: item.classification,
            classificationName: item.classificationName,
            parentClassification: item.parentClassification
          };
        });
        var modulestmp = _this.modules.map(o => ({ ...o }));
        _this.modulesTree = _this.$utils.toArrayTree(modulestmp, {
          key: 'classification',
          parentKey: 'parentClassification',
          strict: true
        });
      });
    },
    beforCreate() {
      this.getModulesTree();
    },
    beforUpdate() {
      this.getModulesTree();
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#txVenClasss-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}
</style>
